import { render, staticRenderFns } from "./bankaccounts.vue?vue&type=template&id=29b09ca4"
import script from "./bankaccounts.vue?vue&type=script&lang=js"
export * from "./bankaccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports